var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "lbs-viewer-popup-header" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v("\n    " + _vm._s(_vm.showName) + "\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "close", on: { click: _vm.callPopupHeader } }, [
      _vm._v("\n    X\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/viewer/components/PopupHeader.vue?vue&type=template&id=1cc739d4&scoped=true&
// module id = 306
// module chunks = 0